import { render } from "./Signup.vue?vue&type=template&id=024d905c"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "/data/vstsagent/user/4153/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Signup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "024d905c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('024d905c', __exports__)) {
    console.log('reload')
    api.reload('024d905c', __exports__)
  }
  
  module.hot.accept("./Signup.vue?vue&type=template&id=024d905c", () => {
    console.log('re-render')
    api.rerender('024d905c', render)
  })

}


export default __exports__